
import React from 'react';
import { Link } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { Plus } from 'lucide-react';

interface CompanyHeaderProps {
  isAdmin: boolean;
}

const CompanyHeader: React.FC<CompanyHeaderProps> = ({ isAdmin }) => {
  return (
    <div className="mb-8 flex justify-between items-center">
      <div>
        <h1 className="text-3xl font-bold mb-2">Companies</h1>
        <p className="text-muted-foreground">Manage the companies in your CRM</p>
      </div>
      {isAdmin && (
        <Button asChild>
          <Link to="/companies/new" className="flex items-center">
            <Plus className="h-4 w-4 mr-2" />
            Add Company
          </Link>
        </Button>
      )}
    </div>
  );
};

export default CompanyHeader;
